/* global axios */

import ApiClient from '../ApiClient';

class JiraAPI extends ApiClient {
  constructor() {
    super('integrations/jira', { accountScoped: true });
  }

  create({
    project,
    domain,
    access_token,
    template_message,
    permitted_issue_types_ids,
  }) {
    return axios.post(this.url, {
      project,
      domain,
      access_token,
      template_message,
      permitted_issue_types_ids,
    });
  }

  delete() {
    return axios.delete(this.url);
  }

  fetchProjects(domain, access_token) {
    return axios.get(`${this.url}/fetch_projects`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      params: {
        domain,
        access_token,
      },
    });
  }

  fetchIssueTypes() {
    return axios.get(`${this.url}/fetch_issue_types`);
  }

  firstFetchIssueTypes(domain, access_token, project_id) {
    return axios.get(`${this.url}/first_fetch_issue_types`, {
      params: {
        domain,
        access_token,
        project: { id: project_id },
      },
    });
  }

  fetchIssueInfo(issueKey) {
    return axios.get(`${this.url}/fetch_issue_info?issue_key=${issueKey}`);
  }

  fetchIssueComments(issueKey) {
    return axios.get(`${this.url}/fetch_issue_comments?issue_key=${issueKey}`);
  }
}

export default new JiraAPI();
